const CasksPage: React.FC<{ children?: React.ReactNode }> = (props) => (
  <div>{props.children}</div>
);

export default CasksPage;
